import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as actions from "redux/actions/profileActions";
import FollowListModalJs from './components/FollowListModal.js';
import { Translate } from "react-redux-i18n";
import { AvatarOrInitials } from 'utils/avatarUtils';
import MiniLoader from 'components/MiniLoader';

const AccountProfile = (props) => {
  const { item, auth } = props;
  const isOwnProfile = item.id && auth.id && item.id.toString() === auth.id.toString();
  const isFollowing = item.follow && Number(item.follow.status) === 1;

  const onClickUpsetFollow = () => {
    if (!props.user_id || !item.id) {
      return;
    }
    props.upsetFollow({
      id: props.user_id,
      follower_id: item.id,
    }, props.token);
  };

  if (props.loading && !item.id) {
    return (
      <div className="profile-card profile-loading">
        <MiniLoader />
      </div>
    );
  }

  if (props.error && !item.id) {
    return (
      <div className="profile-card profile-error">
        <Translate value={props.error === 'try_later' ? 'try_later' : 'not_found'} />
      </div>
    );
  }

  return (
    <div className="profile-card">
      <div className="profile-header">
        <AvatarOrInitials
          avatarUrl={item.avatar}
          name={item.name}
          lastN={item.lastN}
          emailFallback={item.email}
          className="profile-avatar"
          alt={item.username || 'Profile'}
        />
        <div>
          <h2 className="profile-name">
            {[item.name, item.lastN].filter(Boolean).join(' ') || item.username}
          </h2>
          {item.username && (
            <p className="profile-username">@{item.username}</p>
          )}
        </div>

        <div className="profile-stats">
          <div className="profile-stat">
            <span className="profile-stat-value">{item.follow?.followme ?? 0}</span>
            <span className="profile-stat-label">
              <Translate value="following" />
            </span>
          </div>
          <div className="profile-stat">
            <span className="profile-stat-value">{item.follow?.follower ?? 0}</span>
            <span className="profile-stat-label">
              <Translate value="follower" />
            </span>
          </div>
        </div>

        <div className="profile-actions">
          <FollowListModalJs
            button_label={<Translate value="following" />}
            item={item}
            title={<Translate value="following" />}
            kind="following"
            disabled={(item.follow?.followme ?? 0) > 0}
          />
          <FollowListModalJs
            button_label={<Translate value="follower" />}
            item={item}
            title={<Translate value="follower" />}
            kind="followers"
            disabled={(item.follow?.follower ?? 0) > 0}
          />
          {!isOwnProfile && item.id && (
            <button
              type="button"
              className={`profile-follow-btn ${isFollowing ? 'is-following' : ''}`}
              onClick={onClickUpsetFollow}
            >
              {isFollowing ? (
                <Translate value="unfollow" />
              ) : (
                <Translate value="follow" />
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

AccountProfile.propTypes = {
  className: PropTypes.string,
  auth: PropTypes.object,
  followerId: PropTypes.string,
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.token,
    auth: reducer.session.auth,
    item: reducer.profile.item,
    loading: reducer.profile.loading,
    error: reducer.profile.error,
  };
}

const mapDispatchToProps = dispatch => ({
  upsetFollow: (params, token) =>
    dispatch(actions.upsetFollow({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountProfile);
